import type { ReactNode } from 'react';
import { cx } from './components.js';

/** Router-agnostic app layout: sidebar + header + content. Apps pass their own nav (with Links). */
export interface AppShellProps {
  brand: ReactNode;
  sidebar: ReactNode;
  /** Pinned to the bottom of the rail on desktop (e.g. the signed-in user + sign out). */
  sidebarFooter?: ReactNode;
  headerLeft?: ReactNode;
  headerRight?: ReactNode;
  children: ReactNode;
}

export function AppShell({
  brand,
  sidebar,
  sidebarFooter,
  headerLeft,
  headerRight,
  children,
}: AppShellProps) {
  return (
    <div className="dsp-shell">
      <a className="dsp-skip-link" href="#workspace-content">
        Skip to content
      </a>
      <aside className="dsp-shell__sidebar">
        <div className="dsp-shell__brand">{brand}</div>
        {sidebar}
        {sidebarFooter ? (
          <>
            <div className="dsp-shell__sidebar-spacer" />
            <div className="dsp-shell__sidebar-footer">{sidebarFooter}</div>
          </>
        ) : null}
      </aside>
      <div className="dsp-shell__main">
        <header className="dsp-shell__header">
          <div className="dsp-row" style={{ gap: 12, minWidth: 0, flex: '1 1 auto' }}>
            {headerLeft}
          </div>
          <div className="dsp-row" style={{ gap: 12, flexShrink: 0 }}>
            {headerRight}
          </div>
        </header>
        <main id="workspace-content" tabIndex={-1} className="dsp-shell__content">
          {children}
        </main>
      </div>
    </div>
  );
}

/** className helper for nav links (apps wrap their router's Link with this). */
export function navLinkClass(active: boolean): string {
  return cx('dsp-navlink', active && 'dsp-navlink--active');
}
